function Contrast(){
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.66669 9.99984C1.66669 14.6033 5.39653 18.3332 10 18.3332C14.5699 18.3332 18.3334 14.6033 18.3334 9.99984C18.3334 5.42994 14.5699 1.6665 10 1.6665C5.39653 1.6665 1.66669 5.42994 1.66669 9.99984ZM10 16.1826V3.81704C13.3938 3.81704 16.1828 6.60602 16.1828 9.99984C16.1828 13.4273 13.3938 16.1826 10 16.1826Z" fill="#383838"/>
        </svg>
    )
}

export default Contrast;